import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DUPLICATE_REF_TOOLTIP } from "../utils/duplicateRefNumbers";

const DuplicateRefWarning = ({ className = "" }) => (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip
        id="duplicate-ref-warning-tooltip"
        className="duplicate-ref-warning-tooltip"
      >
        {DUPLICATE_REF_TOOLTIP}
      </Tooltip>
    }
  >
    <span
      className={`duplicate-ref-warning ${className}`.trim()}
      style={{ color: "#fcae3a", marginRight: "6px", cursor: "help" }}
    >
      <FontAwesomeIcon icon="exclamation-triangle" />
    </span>
  </OverlayTrigger>
);

export default DuplicateRefWarning;
